var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcNegativeFeedback = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 32.5C10 44.956 19.883 55 32.01 55c4.181 0 8.087-1.19 11.416-3.259a1.5 1.5 0 0 1 1.583 2.548A24.54 24.54 0 0 1 32.01 58C18.168 58 7 46.554 7 32.5S18.168 7 32.01 7s25.01 11.446 25.01 25.5c0 4.435-1.111 8.611-3.069 12.25a1.5 1.5 0 1 1-2.642-1.422A22.8 22.8 0 0 0 54.02 32.5c0-12.456-9.883-22.5-22.01-22.5S10 20.044 10 32.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M23.72 24.163a1.5 1.5 0 0 0-.003 2.122l6.275 6.294-6.27 6.3a1.5 1.5 0 1 0 2.127 2.116l6.26-6.291 6.266 6.285A1.5 1.5 0 1 0 40.5 38.87l-6.274-6.294 6.269-6.299a1.5 1.5 0 0 0-2.127-2.116l-6.26 6.29-6.267-6.285a1.5 1.5 0 0 0-2.12-.004"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcNegativeFeedback);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };